import { createContext } from 'react';

const SmallMobileContext = createContext(false);

export default SmallMobileContext;
